import { BOTTOM, LEFT, RIGHT, ROTATED, TOP, X, Y } from './../../constants';
import { LinearConnectionRouter } from './LinearConnectionRouter';
import { buildConnection, simplifyOrthogonalPoints, resolvePreviewTargetSide } from './CascadingRouting';
const topLeft = 'topLeft';
const bottomRight = 'bottomRight';
export class CascadingRouter extends LinearConnectionRouter {
    constructor(connection) {
        super(connection);
        this.SAME_SIDE_DISTANCE_RATIO = 5;
        this._connectorSides = [{
                name: TOP,
                axis: Y,
                boundsPoint: topLeft,
                secondarySign: 1
            }, {
                name: LEFT,
                axis: X,
                boundsPoint: topLeft,
                secondarySign: 1
            }, {
                name: BOTTOM,
                axis: Y,
                boundsPoint: bottomRight,
                secondarySign: -1
            }, {
                name: RIGHT,
                axis: X,
                boundsPoint: bottomRight,
                secondarySign: -1
            }];
        this.connection = connection;
    }
    routePoints(start, end, sourceConnector, targetConnector) {
        const sourceSide = sourceConnector ? this._connectorSide(sourceConnector, end) : null;
        const targetSide = targetConnector ? this._connectorSide(targetConnector, start) : null;
        return this._createRoute(start, end, sourceSide, targetSide, sourceConnector);
    }
    route() {
        const sourceConnector = this.connection._resolvedSourceConnector;
        const targetConnector = this.connection._resolvedTargetConnector;
        const start = this.connection.sourcePoint();
        const end = this.connection.targetPoint();
        const points = this.routePoints(start, end, sourceConnector, targetConnector);
        const renderPoints = [start, ...points, end];
        const simplified = simplifyOrthogonalPoints(renderPoints);
        this.connection.points(simplified.slice(1, -1));
    }
    _createRoute(source, target, sourceSide, targetSide, sourceConnector) {
        const connector = sourceConnector || this.connection._resolvedSourceConnector;
        const buildOpts = {
            source: source,
            target: target,
            sourceSide: sourceSide,
            targetSide: targetSide || resolvePreviewTargetSide(source, target, this.connection.previewState, { hysteresis: 8 }),
            locks: this.connection.locks,
            anchorOffset: this.connection.options.anchorOffset,
            sameSideDistance: connector ? this._sameSideDistance(connector) : undefined
        };
        const editingEnabled = this.connection.pointsEditable();
        const route = buildConnection(buildOpts, editingEnabled);
        this.connection.route = route;
        this.connection.buildOptions = buildOpts;
        return route.points;
    }
    _connectorSide(connector, targetPoint) {
        const position = connector.positionWithoutOffset();
        const shapeBounds = connector.shape.bounds(ROTATED);
        const bounds = {
            topLeft: shapeBounds.topLeft(),
            bottomRight: shapeBounds.bottomRight()
        };
        const sides = this._connectorSides;
        let min = Number.MAX_VALUE;
        let sideDistance;
        let minSide;
        let axis;
        let side;
        for (let idx = 0; idx < sides.length; idx++) {
            side = sides[idx];
            axis = side.axis;
            sideDistance = Math.round(Math.abs(position[axis] - bounds[side.boundsPoint][axis]));
            if (sideDistance < min) {
                min = sideDistance;
                minSide = side;
            }
            else if (sideDistance === min &&
                (position[axis] - targetPoint[axis]) * side.secondarySign > (position[minSide.axis] - targetPoint[minSide.axis]) * minSide.secondarySign) {
                minSide = side;
            }
        }
        return minSide.name;
    }
    _sameSideDistance(connector) {
        const bounds = connector.shape.bounds(ROTATED);
        return Math.min(bounds.width, bounds.height) / this.SAME_SIDE_DISTANCE_RATIO;
    }
}
